import React from "react";
import QuestionText from "../messages/questionText";
import GetQuestionForm from "./questionForm";

const Question = ({ data, dontShowResetBtn }) => {
  const { id, text, type, items, answer } = data;

  return (<QuestionText
    key={`qt_${id}`}
    message={text}
    form={<GetQuestionForm dontShowResetBtn={dontShowResetBtn} key={`QF_${id}`} id={id} type={type} items={items} answer={answer} />}
  />);
};

export default Question;
